import {Options} from "qr-code-styling/lib/types";

export const qrEst: any = {
    "width": 400,
    "height": 400,
    "data": "https://hildegarden.ee/en/plant/1",
    "margin": 0,
    "qrOptions": {"typeNumber": "0", "mode": "Byte", "errorCorrectionLevel": "Q"},
    "imageOptions": {"hideBackgroundDots": true, "imageSize": 0.4, "margin": 0},
    "dotsOptions": {
        "type": "classy-rounded",
        "color": "#6a1a4c",
        "gradient": {
            "type": "linear",
            "rotation": 0,
            "colorStops": [{"offset": 0, "color": "#38571a"}, {"offset": 1, "color": "#96d35f"}]
        }
    },
    "backgroundOptions": {"color": "#ffffff"},
    "dotsOptionsHelper": {
        "colorType": {"single": true, "gradient": false},
        "gradient": {"linear": true, "radial": false, "color1": "#6a1a4c", "color2": "#6a1a4c", "rotation": "0"}
    },
    "cornersSquareOptions": {"type": "extra-rounded", "color": "#38571a"},
    "cornersSquareOptionsHelper": {
        "colorType": {"single": true, "gradient": false},
        "gradient": {"linear": true, "radial": false, "color1": "#000000", "color2": "#000000", "rotation": "0"}
    },
    "cornersDotOptions": {"type": "", "color": "#38571a"},
    "cornersDotOptionsHelper": {
        "colorType": {"single": true, "gradient": false},
        "gradient": {"linear": true, "radial": false, "color1": "#000000", "color2": "#000000", "rotation": "0"}
    },
    "backgroundOptionsHelper": {
        "colorType": {"single": true, "gradient": false},
        "gradient": {"linear": true, "radial": false, "color1": "#ffffff", "color2": "#ffffff", "rotation": "0"}
    }
}